// removed by extract-text-webpack-plugin
module.exports = {"default_link":"src-components----link-module---default_link---2OcbK","other_link":"src-components----link-module---other_link---1_P9s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/link.module.css
// module id = 112
// module chunks = 114276838955818 162898551421021